var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRedLens(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.164,
    height: 25.164,
    viewBox: "0 0 25.164 25.164",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(-3 -3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "search",
    d: "M27.751,25.766,23,21.029a11.069,11.069,0,0,0,2.362-6.848,11.18,11.18,0,1,0-11.18,11.18A11.069,11.069,0,0,0,21.029,23l4.738,4.752a1.4,1.4,0,1,0,1.985-1.985ZM5.8,14.18a8.385,8.385,0,1,1,8.385,8.385A8.385,8.385,0,0,1,5.8,14.18Z",
    transform: "translate(0 0)",
    fill: "#d71920"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedLens);
export default __webpack_public_path__ + "static/media/RedLens.3234fe8bc4ca980a560e8601b8b5b06f.svg";
export { ForwardRef as ReactComponent };